import { render, staticRenderFns } from "./MarketingStockProducts.vue?vue&type=template&id=0a7ca8a5&scoped=true"
import script from "./MarketingStockProducts.vue?vue&type=script&lang=js"
export * from "./MarketingStockProducts.vue?vue&type=script&lang=js"
import style0 from "./MarketingStockProducts.vue?vue&type=style&index=0&id=0a7ca8a5&prod&scoped=true&lang=css"
import style1 from "./MarketingStockProducts.vue?vue&type=style&index=1&id=0a7ca8a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ca8a5",
  null
  
)

export default component.exports